import * as queryString from "query-string-object";
import baseRequest from "./baseReuqest";

export function getMegafonMessages(page, per_page, order, order_by, filters) {
    let url = '/api/whatsapp/megafon';
    const query = {page, per_page, order, order_by,};

    if (filters?.filterDateStart) {
        query['filter[dateFrom]'] = filters.filterDateStart.format('YYYY-MM-DD');
    }

    if (filters?.filterDateStop) {
        query['filter[dateTo]'] = filters.filterDateStop.format('YYYY-MM-DD');
    }

    const q = queryString.stringify(query);

    if (q) {
        url += `?${q}`;
    }
    return baseRequest(url);
}

export async function getAllMegafonChannel(page, per_page, order, order_by) {
    let url = '/api/megafon/all';
    const q = queryString.stringify({page, per_page, order, order_by});
    if (q) {
        url += `?${q}`;
    }
    return baseRequest(url);
}


